"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcSuggestProductOption = exports.UcProductMiniCard = exports.UcProductInvoiceGroupLabel = void 0;
const UcProductInvoiceGroupLabel_yaml_component_1 = __importDefault(require("./UcProductInvoiceGroupLabel.yaml?component"));
exports.UcProductInvoiceGroupLabel = UcProductInvoiceGroupLabel_yaml_component_1.default;
const UcProductMiniCard_yaml_component_1 = __importDefault(require("./UcProductMiniCard.yaml?component"));
exports.UcProductMiniCard = UcProductMiniCard_yaml_component_1.default;
const UcSuggestProductOption_yaml_component_1 = __importDefault(require("./UcSuggestProductOption.yaml?component"));
exports.UcSuggestProductOption = UcSuggestProductOption_yaml_component_1.default;
